import { Swiper } from "swiper";
import { Mousewheel } from "swiper/modules";

import "./projects.scss";

const selectors = {
  projects: "[data-projects]",
  projectsSlider: "[data-projects-swiper]",
};

const initProjects = (container) => {
  new Swiper(container.querySelector(selectors.projectsSlider), {
    modules: [Mousewheel],

    slidesPerView: "auto",
    spaceBetween: 16,

    mousewheel: {
      forceToAxis: true,
    },
  });
};

document.addEventListener("DOMContentLoaded", async function () {
  const containers = document.querySelectorAll(selectors.projects);

  containers?.forEach(initProjects);
});
